"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMJumpBuilder = void 0;
class VMJumpBuilder {
    constructor(context, jumpIndex) {
        this.jumpIndex = jumpIndex;
        this.context = context;
    }
    patchToHere() {
        this.patchTo(this.context.instructions.length);
    }
    patchTo(target) {
        const instr = this.context.instructions[this.jumpIndex];
        if (!instr || !('target' in instr)) {
            throw new Error(`Invalid jump instruction at index ${this.jumpIndex}`);
        }
        instr.target = target;
    }
    getIndex() {
        return this.jumpIndex;
    }
}
exports.VMJumpBuilder = VMJumpBuilder;
